﻿$.fn.dxCtrlBuilderEmailTypeSaisieHtmlCode = function custom_dxCtrlBuilderEmailSaisieHtmlCode(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailsaisiehtmlcode dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailSaisieHtmlCode(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailSaisieHtmlCode = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var $TxtArea = $('<textarea style="width: 100%;"></textarea>').appendTo(container);
        $TxtArea.val(option.value);
        var editorMirror = null
        window.setTimeout(function () {
            editorMirror = CodeMirror.fromTextArea($TxtArea[0], {
                mode: "text/html",
                autoCloseTags: true,
                styleActiveLine: true,
                lineNumbers: true,
                extraKeys: { "Ctrl-Space": "autocomplete" },
                highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                theme: "dracula",
                matchBrackets: true,
                lineWrapping: true
            });
            editorMirror.on("change", function () {
                if (contentElement.closest("body").length == 0) return
                option.value = editorMirror.getValue()
                if (oldHtml != option.value) {
                    oldHtml = option.value
                    option.onValueChanged(option.value)
                }
            });
        }, 0)
    }

    this.element = function () { return container }

    mConstruit();
}